import React, { Component, Fragment } from 'react';
import { withLayout } from '../../HOC/WithLayout';
import { Link } from 'react-router-dom';
import { isAdmin, isCustomer, isUser } from '../../_utils/user';

class HomePage extends Component {
    render() {
        return (
            <section className="section">
                <div className="container">
                    <div className="columns">
                        <div className="column is-half is-offset-one-quarter">
                            <section className="card my-5">
                                <header className="card-header">
                                    <p className="card-header-title">
                                        Bienvenido a Tropical Casting
                                    </p>
                                </header>
                                <div className="card-content p-2">
                                    <p className="mb-2">Acceso rápido a:</p>
                                    <div className="buttons">
                                        {isAdmin(this.props.user) || isCustomer(this.props.user)
                                            ? <Link className="button is-primary" to="/projects/">
                                                Proyectos
                                            </Link>
                                            : null
                                        }
                                        {isAdmin(this.props.user)
                                            ? <Fragment>
                                                <Link className="button" to="/profiles/">
                                                    Perfiles
                                                </Link>
                                                <Link className="button" to="/customers/">
                                                    Clientes
                                                </Link>
                                            </Fragment>
                                            : null
                                        }
                                        {isUser(this.props.user)
                                            ? <Link className="button is-primary"
                                                    to={`profiles/${this.props.user.pid}`}>
                                                Edita tu perfil
                                            </Link>
                                            : null
                                        }
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default withLayout(HomePage);